export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-side-back-twist-WEB-THUMB-7c02fd4a86b12893b3c3331bb990c190.jpg";